import React from 'react'

const LocaleContext = React.createContext(null)

export default LocaleContext